import { useEffect, useState } from 'react';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';
import { useErrorBoundary } from 'react-error-boundary';


interface Bank {
  name: string;
  id: number;
  longName: string;
}


const BankList = (): JSX.Element => {

  const { showBoundary } = useErrorBoundary();
  const [banks, setBanks] = useState<Bank[]>([]);

  const content: InfoItemBoxProps[] = [
  {
    title: 'Participating Banks in OCPF Depository Reporting System *',
    blocks: [
      {
        type: "list",
        listType: "bullet",
        items: banks?.map(bank => ({
          content: [
            {
              type: "text",
              content: bank.name
            }
          ]
        }))
      },
      {
        type: 'paragraph',
        content: [
          {type: "text", content: "* If your bank is not in the above list, please contact OCPF (617-979-8300, ocpf@mass.gov) for more information." }
        ]
      }
      
    ]
  }
  ];

  useEffect(() => {
    getBankList();
  }, []);

  const getBankList = async () =>{

    try{
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/participatingBanks`);
      if (!response.ok) {
        showBoundary(new Error('Failed to get bank list from the server'));
      }
      const banks = await response.json();
      setBanks(banks);
    }
    catch(error) {
      showBoundary(new Error(`Failed to get bank list from the server: ${error}`));
      console.error('Uncaught Error:', error);
    }
  }

  return (
    <div>
     {content.map((content, index) => (
      <InfoItemBox key={index} {...content} />
    ))}
  </div>
   
  );
};

export default BankList;
